const GET_ALL_REQUEST_TYPE_LIST = 'GET_ALL_REQUEST_TYPE_LIST';
const SET_ALL_REQUEST_TYPE_LIST = 'SET_ALL_REQUEST_TYPE_LIST';

const GET_STATUS_LIST = 'GET_STATUS_LIST';
const SET_STATUS_LIST = 'SET_STATUS_LIST';

const GET_REGION_LIST = 'GET_REGION_LIST';
const SET_REGION_LIST = 'SET_REGION_LIST';

const GET_COST_CENTER_LIST = 'GET_COST_CENTER_LIST';
const SET_COST_CENTER_LIST = 'SET_COST_CENTER_LIST';

const GET_REQUESTED_BY_LIST = 'GET_REQUESTED_BY_LIST';
const SET_REQUESTED_BY_LIST = 'SET_REQUESTED_BY_LIST';

const GET_ASSIGNED_TO_LIST = 'GET_ASSIGNED_TO_LIST';
const SET_ASSIGNED_TO_LIST = 'SET_ASSIGNED_TO_LIST';

const GET_UPDATED_BY_LIST = 'GET_UPDATED_BY_LIST';
const SET_UPDATED_BY_LIST = 'SET_UPDATED_BY_LIST';

const IS_DROP_DOWNS_LOADING = 'IS_DROP_DOWNS_LOADING'
const GET_BUYER_NAME_LIST = 'GET_BUYER_NAME_LIST'
const SET_BUYER_NAME_LIST = 'SET_BUYER_NAME_LIST'

const GET_FLEET_PROCESSORS = "GET_FLEET_PROCESSORS"
const SET_FLEET_PROCESSORS = "SET_FLEET_PROCESSORS"

export
{
    GET_ALL_REQUEST_TYPE_LIST,
    SET_ALL_REQUEST_TYPE_LIST,
    GET_STATUS_LIST,
    SET_STATUS_LIST,
    GET_REGION_LIST,
    SET_REGION_LIST,
    GET_COST_CENTER_LIST,
    SET_COST_CENTER_LIST,
    GET_REQUESTED_BY_LIST,
    SET_REQUESTED_BY_LIST,
    GET_ASSIGNED_TO_LIST,
    SET_ASSIGNED_TO_LIST,
    GET_UPDATED_BY_LIST,
    SET_UPDATED_BY_LIST,
    IS_DROP_DOWNS_LOADING,
    GET_BUYER_NAME_LIST,
    SET_BUYER_NAME_LIST,
    GET_FLEET_PROCESSORS,
    SET_FLEET_PROCESSORS
};